<template>
  <div class="emoji-wrapper">
    <div
      v-for="reaction in reactions"
      class="emoji-item"
      :style="{ fontSize: size+'px', padding: `${gutter}px ${4*gutter}px` }"
      :key="`${reaction.type}-${reaction.users.length}`"
    >
      <v-menu
        open-on-hover
        bottom
        offset-y
      >
        <template v-slot:activator="{ on }">
          <span
            v-on="on"
            @click="$emit('reactionClicked', reaction)"
          >
            <v-badge
              color="primary"
              :content="reaction.users.length"
              :value="reaction.users.length > 1"
            >
              <v-img
                v-if="reaction.type.split('.')[1]"
                :src="require(`../../../assets/reactions/${reaction.type}`)"
                :alt="reactions.find(item => item.type === reaction.type).title"
                contain
                :height="size"
                :width="size"
              />
              <span v-else> {{ reaction.type }} </span>
            </v-badge>
          </span>
        </template>
        <v-card class="pa-2">
          {{ reactionUsersList(reaction) }}
        </v-card>
      </v-menu>
    </div>
  </div>
</template>

<script>
export default {
  name: "EmojiReactions",
  props: {
    reactions: {
      type: Array,
      default: () => []
    },
    size: {
      type: Number,
      default: 12
    },
    gutter: {
      type: Number,
      default: 0
    },
    chatUsers: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    reactionUsersList (reaction) {
      return reaction.users
        .map(user =>
          (this.chatUsers.find(chatUser => chatUser.uuid === user.user) || {}).fullName || user.user
        )
        .join(', ')
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";
  .emoji {
    &-wrapper {
      display: flex;
    }
    &-item {
      cursor: pointer;
      margin-right: 0.5*$gutter;
      background-color: $bh-blue--4;
      border-radius: 0.5*$gutter;
    }
  }
</style>
